import { useAccountDataQuery } from 'queries/account';

export enum AddonFeature {
  User = 1,
  Partners = 21,
  Rbac = 22,
  TimeTrackingUsers = 38,
  SupportCosts = 39,
  LiteUsers = 27,
  CustomReport = 40,
  SkillMatrix = 45,
  ResourceRequest = 44,
  Invoice = 52,
  InvoiceApprovalChains = 53,
  AdditionalDependencies = 54,
  Expense = 154,
  ExpenseApprovalChains = 55,
  MultiBudget = 68,
  BillingSchedule = 80,
}

const nonRbacAddonAccountIds = [
  12059, // this is the account id for uniqus
  400, // this is the account id for growth molecules
];

export const useAddon = (addonFeature: AddonFeature): boolean => {
  const { data: accountData } = useAccountDataQuery();

  const isTheAddonPresent = Boolean(
    accountData?.billingMeta?.subscription?.addons?.find(
      (addon) => addon?.addonId === addonFeature,
    ),
  );

  if (addonFeature === AddonFeature.Rbac) {
    return (
      isTheAddonPresent ||
      nonRbacAddonAccountIds.includes(accountData?.account?.accountId ?? -1)
    );
  }

  return isTheAddonPresent;
};
